import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/**
 * showSuccess / showError are thin wrappers
 * so the rest of your app never needs to import 'react-toastify' directly.
 */
export const showSuccess = (msg: string) => toast.success(msg);
export const showError = (msg: string) => toast.error(msg);

const AlertContainer: React.FC = () => (
  <ToastContainer
    position="top-right"
    autoClose={4000}
    hideProgressBar={false}
    newestOnTop
    closeOnClick
    pauseOnHover
    draggable
    pauseOnFocusLoss
  />
);

export default AlertContainer;
